import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=ab83b23c&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=ab83b23c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab83b23c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab83b23c')) {
      api.createRecord('ab83b23c', component.options)
    } else {
      api.reload('ab83b23c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=ab83b23c&scoped=true&", function () {
      api.rerender('ab83b23c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tralvelInfo/detail.vue"
export default component.exports